<app-navigate></app-navigate>
<router-outlet></router-outlet>
<div class="max-w-screen-2xl mx-auto">
  <app-links></app-links>
  <app-footer></app-footer>
</div>
@if (trialData(); as data) {
  <app-free-trial [freeTrialData]="data" [isDialog]="true"></app-free-trial>
}
